import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-172a7eec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emalphone" }
const _hoisted_2 = {
  key: 0,
  style: {"margin":"0px 0 34px"},
  class: "position_box"
}
const _hoisted_3 = {
  key: 0,
  class: "hint_box"
}
const _hoisted_4 = { class: "position_ab_box" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  style: {"margin-bottom":"34px"},
  class: "position_box"
}
const _hoisted_7 = { class: "inputBox" }
const _hoisted_8 = { class: "serial" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "trilateral" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "hint_box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.isEmail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_van_field, {
            modelValue: $setup.verify.email,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (($setup.verify.email) = $event)),
              _cache[3] || (_cache[3] = ($event: any) => ($setup.editEmailFn()))
            ],
            modelModifiers: { trim: true },
            class: "inputBox",
            style: {"height":"28px"},
            center: "",
            clearable: "",
            autofocus: "",
            "left-icon": "envelop-o",
            placeholder: "Enter your Email",
            onClear: _cache[1] || (_cache[1] = ($event: any) => ($setup.isEmailHint = false)),
            onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.verifyEmail()))
          }, null, 8, ["modelValue"]), [
            [_directive_focus]
          ]),
          ($setup.isEmailHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Please input a valid email address."))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.emailArr.list, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                onClick: ($event: any) => ($setup.getEmailNumFn(item))
              }, _toDisplayString(item), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vShow, $setup.suffix_email]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_van_icon, {
              name: 'https://image.kilimall.com/kenya/wap/icons/phonelcon.png'.webpFilters(),
              size: "18"
            }, null, 8, ["name"]),
            _createVNode(_component_van_popover, {
              show: $setup.showPopover,
              "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.showPopover) = $event)),
              actions: $setup.actions,
              onSelect: $setup.onSelect,
              class: "drop-down"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, " +" + _toDisplayString($setup.country_code), 1),
                  _hoisted_9
                ])
              ]),
              _: 1
            }, 8, ["show", "actions", "onSelect"]),
            _withDirectives(_createVNode(_component_van_field, {
              class: "phoneInput",
              modelValue: $setup.verify.phone,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => (($setup.verify.phone) = $event)),
                _cache[8] || (_cache[8] = ($event: any) => ($setup.verifyPhone()))
              ],
              modelModifiers: { trim: true },
              type: "tel",
              center: "",
              autofocus: "",
              clearable: "",
              placeholder: "e.g. 700200100",
              onClear: _cache[6] || (_cache[6] = ($event: any) => ($setup.isPhoneHint = false)),
              onBlur: _cache[7] || (_cache[7] = ($event: any) => ($setup.verifyPhone()))
            }, null, 8, ["modelValue"]), [
              [_directive_focus]
            ])
          ]),
          ($setup.isPhoneHint)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Please input valid phone number."))
            : _createCommentVNode("", true)
        ])),
    _renderSlot(_ctx.$slots, "center", {}, undefined, true),
    _createVNode(_component_van_field, {
      modelValue: $setup.verify.code,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.verify.code) = $event)),
      modelModifiers: { trim: true },
      class: "inputBox",
      center: "",
      clearable: "",
      type: "digit",
      "left-icon": "chat-o",
      placeholder: $props.isEmail?'Enter Email code' : 'Enter SMS code',
      rules: [{ required: true }]
    }, {
      button: _withCtx(() => [
        _createVNode(_component_van_button, {
          size: "small",
          type: "primary",
          onClick: $setup.getCaptcha,
          disabled: $setup.waiting > 0,
          class: "resend_box",
          style: _normalizeStyle([$setup.waiting > 0? 'border-color:#999;color:#999;min-width:100px': 'color: #F87622;' ])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.waiting > 0  ? 'Wait ('+$setup.waiting+'s)' :  $setup.count >= 1?'Resend':'Send'), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled", "style"])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"])
  ]))
}